export default __webpack_public_path__ + "static/media/Discount_Grid_Image.166ef6e4.jpg";